import { Dispatch } from 'redux'
import {
  add as addAction,
  set as setAction,
  setLoading,
  setSelectedData,
  update as updateAction
} from 'states/dux/document/actions'
import { Payload } from 'states/dux/document/types'
import { Action } from 'states/types'
import { NivosFolder } from 'types/nivos-folder'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (folders: NivosFolder[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: folders
      })
    )
}

const update = (folder: NivosFolder): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [folder]
      })
    )
}

const add = (folders: NivosFolder): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [folders]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

const setSelected = (state: any): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(setSelectedData(state))
}

export interface Operations {
  set: (folders: NivosFolder[]) => DispatchAction
  add: (folder: NivosFolder) => DispatchAction
  update: (folder: NivosFolder) => DispatchAction
  loading: (loading: boolean) => DispatchAction
  setSelected: (state: any) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  update,
  loading,
  setSelected
}

export { operations }
